
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VCheckbox from 'vuetify/lib/components/VCheckbox/VCheckbox';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import { FeaturesStore } from '@/features/features-store';

const featureStore = getModule(FeaturesStore);

const base = Vue.extend({ mixins: [VCheckbox] });
export default base.extend({
    name: 'base-chip',
    props: {
        onIcon: {
            type: String,
            default: 'mdi-checkbox-marked'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // add our CSS classes to the default vuetify classes
        classes(): object {
            return {
                ...VCheckbox.options.computed.classes.call(this),
                'base-checkbox': true
            };
        }
    },
    created() {
        const props = this.$options.props as { onIcon: { default: string } };
        props.onIcon.default = featureStore.isHcmNewCrmUi
            ? 'fa-square-check'
            : 'fa-duotone fa-thin fa-square-check';
    }
});
